"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRecipeSearch = exports.viewRecipeSearchQuery = void 0;
const client_1 = require("@apollo/client");
const recipeName_1 = require("../../fragments/recipeName");
exports.viewRecipeSearchQuery = client_1.gql `
  query ViewRecipeSearch(
    $searchQuery: String!
    $offset: Int!
    $recipesNotInCookbooks: Boolean
  ) {
    recipeSearch(
      searchQuery: $searchQuery
      offset: $offset
      recipesNotInCookbooks: $recipesNotInCookbooks
    ) @connection(key: "recipeSearch") {
      __typename
      hasMoreRecipes
      recipes {
        cookbookSectionLookup {
          cookbook {
            id
            name
            accessLevel
          }
          section {
            id
            name
          }
        }
        ...recipeName
      }
    }
  }
  ${recipeName_1.recipeNameFragment}
`;
exports.useRecipeSearch = (_a) => {
    var { query } = _a, options = __rest(_a, ["query"]);
    const { data, loading, fetchMore, refetch, networkStatus } = client_1.useQuery(query, options);
    let recipes = [];
    let hasMoreRecipes = false;
    if (data && data.recipeSearch && data.recipeSearch.recipes) {
        recipes = data.recipeSearch.recipes;
        hasMoreRecipes = data.recipeSearch.hasMoreRecipes;
    }
    return {
        networkStatus,
        refetch,
        loading,
        loadMore: () => {
            if (!recipes.length || loading) {
                return;
            }
            return fetchMore({
                variables: Object.assign(Object.assign({}, options.variables), { offset: recipes.length }),
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    if (!fetchMoreResult) {
                        return previousResult;
                    }
                    return Object.assign(Object.assign({}, previousResult), { recipeSearch: Object.assign(Object.assign({}, previousResult.recipeSearch), { recipes: [
                                ...(previousResult.recipeSearch.recipes || []),
                                ...(fetchMoreResult.recipeSearch.recipes || []),
                            ], hasMoreRecipes: fetchMoreResult.recipeSearch.hasMoreRecipes }) });
                },
            });
        },
        hasMoreRecipes,
        recipes,
    };
};
//# sourceMappingURL=ViewRecipeSearch.js.map